import React from "react";

class GameLayout extends React.Component {
  render() {
    return <>{this.props.children}</>;
  }
}

export default GameLayout;
